
var onloadCallback = function() {
  grecaptcha.enterprise.render('html_element', {
    'sitekey' : '6LcT-BomAAAAAINAthwtFsRPmpIa4065N92f2whr',
  });
};
// grecaptcha.enterprise.ready(function() {
//   grecaptcha.enterprise.execute('6LdSCB8mAAAAAPdDkTXUNV8uJib74zXAivjXfClI', {action: 'login'}).then(function(token) {
//      //console.log(token);
//      document.querySelector("#token").setAttribute("data-token", token);

//   });
// });
